<template>
  <div class="app-router">
    <h2 class="font-weight-bold pb-5">Tambah Produk</h2>
    <div class="d-block text-subtitle-2 pb-3">
      Pastikan produk Anda sudah sesuai dengan syarat dan ketentuan. Kami
      menghimbau seller untuk menjual produk dengan harga yang wajar atau produk
      Anda dapat diturunkan sesuai S&K yang berlaku.
    </div>

    <v-form ref="formAddProduct" role="form">
      <v-card
        outlined
        class="px-3 py-3 my-5"
        v-if="$route.name == 'seller-produk-tambah'"
      >
        <v-card-title
          class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4"
        >
          Upload Gambar Produk
          <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
        </v-card-title>
        <v-card-text class="px-2">
          <div class="text-caption">
            Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300 px (Untuk
            gambar optimal gunakan minimum 700 x 700 px)
          </div>
          <div class="text-center mt-3" v-if="image_alert">
            <v-alert
              class="white--text red lighten-1"
              dense
              dismissible
              @input="toggleAlert"
              v-model="image_alert"
              >Produk harus disertai gambar</v-alert
            >
          </div>

          <v-row class="my-5 d-flex align-center justify-center flex-row">
            <v-col cols="4" sm="2" v-for="(img, idg) in imgProduct" :key="idg">
              <div
                class="product-img d-row outlined py-4 px-4"
                :class="img ? '' : 'emptyImg'"
              >
                <v-img
                  width="100%"
                  :src="img ? img : '/assets/seller/add-image-icon.svg'"
                ></v-img>
                <v-btn
                  v-if="img"
                  class="mx-0 close-btn"
                  fab
                  dark
                  x-small
                  color="red"
                  @click="removeImage(idg)"
                >
                  <v-icon dark>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <div v-show="false">
            <v-file-input
              @change="createImage($event)"
              id="inputProdukImg"
              ref="fileupload"
              chips
              accept="image/*"
              multiple
              small-chips
              prepend-icon
              truncate-length="50"
            ></v-file-input>
          </div>
          <div class="v-row d-flex flex-column align-center">
            <v-btn
              color="black"
              elevation="2"
              dark
              min-width="140"
              class="my-3"
              @click="openUpload"
            >
              <strong class="text-capitalize text-subtitle-2 font-weight-bold">
                <v-icon color="white darken-1 mr-2">mdi-plus</v-icon>Pilih
                Gambar Produk
              </strong>
            </v-btn>

            <!-- <v-btn
              color="warning"
              elevation="2"
              dark
              min-width="140"
              class="my-3"
              v-else
            >
              <strong class="text-capitalize text-subtitle-2 font-weight-bold"><v-icon color="white darken-1 mr-2">mdi-upload</v-icon> Upload Produk</strong>
            </v-btn>-->
            <div class="text-caption font-weight-bold">
              Letakkan hingga 5 gambar sekaligus disini.
            </div>
          </div>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title
          class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4"
          >Informasi Produk</v-card-title
        >
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Nama Produk
                <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
              </div>
              <p class="mb-0 text-caption grey--text">
                Nama min. 5 karakter, terdiri dari jenis produk, merek, dan
                keterangan seperti warna, bahan, atau tipe.
              </p>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-text-field
                :rules="nameRules"
                v-model="produkInput.nama"
                outlined
                small
                dense
                counter="70"
                placeholder="Masukkan nama produk"
                :error-messages="responseError.name"
                @focus="() => (responseError.name = '')"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Kategori
                <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <!-- {{produkInput.kategori}} -->
              <!-- {{selectedCategoryArr.product_category_fee_minimum}} -->
              <!-- {{category}} -->
              <v-autocomplete
                @change="getCategorySelected(produkInput.kategori)"
                :rules="categoryRules"
                v-model="produkInput.kategori"
                :items="category"
                item-value="product_category_id"
                item-text="product_category_name"
                placeholder="Pilih Kategori"
                hide-details="auto"
                :auto-select-first="true"
                outlined
                dense
                :error-messages="responseError.category"
                @focus="() => (responseError.category = '')"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Jenis File Produk
                <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <!-- {{produkInput.kategori}} -->
              <!-- {{selectedCategoryArr.product_category_fee_minimum}} -->
              <!-- {{category}} -->
              <v-autocomplete 
                @change="getPhysiqueSelected(produkInput.product_physique)"
                :rules="physiqueRules"
                v-model="produkInput.product_physique"
                :items="productPhysiqueData"
                item-value="value"
                item-text="label"
                placeholder="Pilih Jenis File Produk"
                hide-details="auto"
                :auto-select-first="true"
                outlined
                dense
                :error-messages="responseError.physiqueRules"
                @focus="() => (responseError.physiqueRules = '')"
              ></v-autocomplete>
            </v-col>
          </v-row> 
            
            <v-row v-if="produkInput.product_physique == 'ebook'">
              <v-col cols="12" sm="4" class="pb0-xs">
                <div class="d-block text-subtitle-2 font-weight-bold black--text">
                  Tipe File Produk
                  <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
                </div>
              </v-col>
              <v-col cols="12" sm="8" class="pb0-xs">
                <!-- {{produkInput.kategori}} -->
                <!-- {{selectedCategoryArr.product_category_fee_minimum}} -->
                <!-- {{category}} -->
                <v-autocomplete
                  @change="
                    getEbookFileTypeSelected(produkInput.product_ebook_file_type)
                  "
                  v-model="produkInput.product_ebook_file_type"
                  :items="productEbookFileTypeData"
                  item-value="value"
                  item-text="label"
                  placeholder="Pilih Tipe File Produk"
                  hide-details="auto"
                  :auto-select-first="true"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="produkInput.product_physique == 'ebook' && produkInput.product_ebook_file_type == 'image'">
              <v-col cols="12" sm="4" class="pb0-xs">
                <div class="d-block text-subtitle-2 font-weight-bold black--text">
                  Orientasi File Produk
                  <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
                </div>
              </v-col>
              <v-col cols="12" sm="8" class="pb0-xs">
                <!-- {{produkInput.kategori}} -->
                <!-- {{selectedCategoryArr.product_category_fee_minimum}} -->
                <!-- {{category}} -->
                <v-autocomplete
                  v-model="produkInput.product_ebook_orientation"
                  :items="productEbookOrientationData"
                  item-value="value"
                  item-text="label"
                  placeholder="Pilih Orientasi File Produk"
                  hide-details="auto"
                  :auto-select-first="true"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row>
            <upload-file
              v-if="checkUploadEbook"
              :type="produkInput.product_ebook_file_type"
              :listData="produkInput.product_ebook_files"
              :orientation="produkInput.product_ebook_orientation"
            />
    
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title
          class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4"
          >Detail Produk</v-card-title
        >
        <v-card-text class="px-2 pb-0">
          <v-row v-if="false">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Kondisi
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-radio-group
                v-model="produkInput.kondisi"
                hide-details="auto"
                row
              >
                <v-radio label="Baru" value="1"></v-radio>
                <v-radio label="Bekas" value="0"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Satuan
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-autocomplete
                v-model="produkInput.unit"
                :items="units"
                :rules="unitRules"
                placeholder="Satuan"
                hide-details="auto"
                outlined
                dense
                :error-messages="responseError.unit"
                @focus="() => (responseError.unit = '')"
              >
                <template v-slot:selection="{ item }">
                  <span class="text-capitalize">{{ item }}</span>
                </template>
                <template v-slot:item="{ item }">
                  <span class="text-capitalize">{{ item }}</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Deskripsi Produk
              </div>
              <p class="mb-0 text-caption grey--text">
                Pastikan deskripsi produk memuat spesifikasi, ukuran, bahan,
                masa berlaku, dan lainnya. Semakin detail, semakin berguna bagi
                pembeli.
              </p>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-textarea
                v-model="produkInput.deskripsi"
                outlined
                small
                dense
                no-resize
                rows="5"
                counter="2000"
                :error-messages="responseError.description"
                @focus="() => (responseError.description = '')"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5" v-if="detailStore">
        <v-card-title
          class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4"
          >Harga Produk</v-card-title
        >
        <v-card-text class="px-2">
          <v-row v-if="false">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Minimum Pemesanan
              </div>
              <p class="mb-0 text-caption grey--text">
                Atur jumlah minimum yang harus dibeli untuk produk ini.
              </p>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-text-field
                v-model="produkInput.minOrder"
                outlined
                small
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Harga Satuan
                <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field
                @change="calculatePrice"
                v-model="produkInput.product_gross"
                :rules="priceRules"
                outlined
                small
                dense
                placeholder="Masukkan harga"
                prefix="Rp"
                hide-details="auto"
                :error-messages="responseError.price"
                @focus="() => (responseError.price = '')"
                persistent-hint
                hint="Harga jual produk ke konsumen"
              ></v-currency-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Diskon Produk
              </div>
            </v-col>
            <v-col cols="12" sm="2" class="pb0-xs">
              <v-switch
                @change="isEnableDiscount"
                v-model="produkInput.product_enable_discount"
                class="my-0 py-0"
                inset
                hide-details="auto"
                true-value="1"
                false-value="0"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row v-show="produkInput.product_enable_discount == 1">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Tipe Diskon
              </div>
            </v-col>
            <v-col cols="12" sm="2" class="pb0-xs">
              <v-radio-group
                v-model="produkInput.product_discount_type"
                hide-details="auto"
                row
                class="my-0"
                @change="calculatePrice"
              >
                <v-radio label="Nominal" value="nominal"></v-radio>
                <v-radio label="Persentase" value="percent"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row
            v-show="
              produkInput.product_enable_discount == 1 &&
              produkInput.product_discount_type == 'percent'
            "
          >
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Persentase Diskon
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                  >Wajib</v-chip
                >
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field
                @change="calculatePrice"
                :maxlength="3"
                :max="70"
                v-model="produkInput.product_discount_percent"
                :rules="valueRules"
                outlined
                small
                dense
                placeholder="Masukkan persentase diskon"
                prefix="%"
                hide-details="auto"
                :error-messages="responseError.price"
                @focus="() => (responseError.price = '')"
                persistent-hint
                hint="Maksimal 70%"
              ></v-currency-field>
            </v-col>
          </v-row>
          <v-row
            v-show="
              produkInput.product_enable_discount == 1 &&
              produkInput.product_discount_type == 'nominal'
            "
          >
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Nominal Diskon
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                  >Wajib</v-chip
                >
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field
                @change="calculatePrice"
                v-model="produkInput.product_discount_nominal"
                :rules="valueRules"
                outlined
                small
                dense
                placeholder="Masukkan nominal diskon"
                prefix="Rp"
                hide-details="auto"
                :error-messages="responseError.price"
                @focus="() => (responseError.price = '')"
                persistent-hint
                hint="Nilai nominal diskon"
              ></v-currency-field>
            </v-col>
          </v-row>
          <v-row v-show="produkInput.product_enable_discount == 1">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Harga Akhir
                <!-- <v-chip x-small class="ma-2 py-2 font-weight-bold" color="blue" outlined></v-chip> -->
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field
                :readonly="true"
                v-model="produkInput.hargaSatuan"
                :rules="priceRules"
                outlined
                small
                dense
                placeholder="Masukkan harga"
                prefix="Rp"
                hide-details="auto"
                :error-messages="responseError.price"
                @focus="() => (responseError.price = '')"
                persistent-hint
                hint="Dihitung otomatis"
              ></v-currency-field>
            </v-col>
          </v-row>
          <v-row v-if="detailStore.store_is_b2b == 'true'">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Harga B2B
                <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field
                v-model="produkInput.hargaB2b"
                :rules="priceB2bRules"
                outlined
                small
                dense
                placeholder="Masukkan harga"
                prefix="Rp"
                hide-details="auto"
                :error-messages="responseError.price_original"
                @focus="() => (responseError.price_original = '')"
                persistent-hint
                hint="Harga jual dari perusahaan"
              ></v-currency-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card outlined class="px-3 py-3 my-5" v-if="detailStore">
        <v-card-title
          class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4"
          >Biaya Layanan Produk</v-card-title
        >
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Persentase
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                  >Wajib</v-chip
                >
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <!-- <v-select
                :rules="valueRules"
                v-model="produkInput.product_fee"
                :items="biayaLayananList"
                item-text="title"
                item-value="value"
                placeholder="Pilih Biaya Layanan"
                hide-details="auto"
                :auto-select-first="true"
                outlined
                dense
                :error-messages="responseError.product_fee"
                @focus="() => responseError.product_fee=''"
              ></v-select>-->
              <v-text-field
                :readonly="true"
                :rules="valueRules"
                v-model="produkInput.product_fee"
                outlined
                small
                dense
                placeholder="Biaya Layanan"
                :error-messages="responseError.product_fee"
                @focus="() => (responseError.product_fee = '')"
              ></v-text-field>
              <small class="text-muted"
                >Biaya layanan berdasarkan Kategori Produk.</small
              >
            </v-col>
            <v-col cols="12" sm="6" class="pb0-xs">
              <!-- <small
                v-if="selectedCategoryArr.product_category_fee_minimum>0"
              >Produk akan otomatis tayang jika biaya layanan minimal senilai {{(selectedCategoryArr.product_category_fee_minimum*1)}}%.</small>-->
              <!-- <p class="text-muted">Biaya layanan menentukan Cashback untuk pelanggan Anda</p> -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title
          class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4"
          >Pengelolaan Produk</v-card-title
        >
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Status Produk
              </div>
            </v-col>
            <v-col cols="12" sm="2" class="pb0-xs">
              <v-switch
                v-model="produkInput.status"
                class="my-0 py-0"
                inset
                hide-details="auto"
                true-value="active"
                false-value="inactive"
                dense
              ></v-switch>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Stok Produk
                <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field
                v-model="produkInput.stok"
                :rules="stockRules"
                outlined
                small
                dense
                placeholder="Masukkan jumlah stok"
                hide-details="auto"
                :error-messages="responseError.quantity"
                @focus="() => (responseError.quantity = '')"
              ></v-currency-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                SKU (Stock Keeping Unit)
              </div>
              <p class="mb-0 text-caption grey--text">
                Gunakan kode unik SKU jika kamu ingin menandai produkmu.
              </p>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-text-field
                v-model="produkInput.code"
                outlined
                small
                dense
                placeholder="Masukkan Kode Produk"
                :error-messages="responseError.code"
                @focus="() => (responseError.code = '')"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        outlined
        class="px-3 py-3 my-5"
        v-if="produkInput.product_physique == 'physique'"
      >
        <v-card-title
          class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4"
          >Berat &amp; Pengiriman Produk</v-card-title
        >
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Berat Produk
                <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
              </div>
              <p class="mb-0 text-caption grey--text">
                Masukkan berat dengan menimbang produk setelah dikemas.
              </p>
            </v-col>

            <v-col cols="12" sm="3" class="pb0-xs">
              <v-autocomplete
                v-model="produkInput.unitberat"
                :items="weightUnits"
                :rules="weightUnitRules"
                item-text="text"
                item-value="multiple"
                placeholder="Satuan"
                hide-details="auto"
                outlined
                dense
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3" class="pb0-xs">
              <v-currency-field
                v-model="produkInput.berat"
                :rules="weightRules"
                outlined
                small
                dense
                hide-details="auto"
                placeholder="Masukkan berat"
                :decimalLength="2"
                :error-messages="responseError.weight"
                @focus="() => (responseError.weight = '')"
              ></v-currency-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Ukuran Produk
              </div>
              <p class="mb-0 text-caption grey--text">
                Masukkan ukuran produk setelah dikemas untuk menghitung berat
                volume
              </p>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-row>
                <v-col cols="12" sm="4" class="pb0-xs">
                  <v-currency-field
                    :label="'Panjang (cm)'"
                    v-model="produkInput.product_length"
                    outlined
                    small
                    dense
                    :error-messages="responseError.product_length"
                    @focus="() => (responseError.product_length = '')"
                  ></v-currency-field>
                </v-col>
                <v-col cols="12" sm="4" class="pb0-xs">
                  <v-currency-field
                    :label="'Lebar (cm)'"
                    v-model="produkInput.product_width"
                    outlined
                    small
                    dense
                    :error-messages="responseError.product_width"
                    @focus="() => (responseError.product_width = '')"
                  ></v-currency-field>
                </v-col>
                <v-col cols="12" sm="4" class="pb0-xs">
                  <v-currency-field
                    :label="'Tinggi (cm)'"
                    v-model="produkInput.product_height"
                    outlined
                    small
                    dense
                    :error-messages="responseError.product_height"
                    @focus="() => (responseError.product_height = '')"
                  ></v-currency-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="false">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Asuransi Pengiriman
              </div>
              <p class="mb-0 text-caption grey--text">
                Gunakan asuransi pengiriman untuk menjamin kerugian, kerusakan,
                &amp; kehilangan selama pengiriman produk.
              </p>
            </v-col>
            <v-col cols="12" sm="8">
              <v-radio-group
                v-model="produkInput.asuransi"
                hide-details="auto"
                row
                class="my-0"
              >
                <v-radio label="Opsional" value="0"></v-radio>
                <v-radio label="Ya" value="1"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>

    <v-layout v-resize="onResize" column>
      <v-card outlined class="px-3 py-3 my-5">
        <v-card-text>
          <v-row>
            <v-col cols="12" class="text-right py-0 px-0">
              <v-btn
                color="error"
                dark
                text
                min-width="140"
                :loading="loadingProcess"
                class="mr-2"
                v-if="!isMobile"
                @click="cancelForm"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold"
                  >Batal</strong
                >
              </v-btn>

              <v-btn
                color="black"
                elevation="2"
                outlined
                dark
                min-width="140"
                :loading="loadingProcess"
                :class="isMobile ? 'v-btn--block mb-3' : 'mr-2'"
                @click="save(1)"
                v-if="!isMobile"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold"
                  >Simpan &amp; Tambah Baru</strong
                >
              </v-btn>

              <v-btn
                color="black"
                elevation="2"
                dark
                min-width="140"
                :loading="loadingProcess"
                :class="isMobile ? 'v-btn--block mb-3' : ''"
                @click="save(2)"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold"
                  >Simpan</strong
                >
              </v-btn>

              <v-btn
                color="black"
                elevation="2"
                outlined
                dark
                :class="isMobile ? 'v-btn--block mb-3' : 'mr-2'"
                min-width="140"
                :loading="loadingProcess"
                @click="save(1)"
                v-if="isMobile"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold"
                  >Simpan &amp; Tambah Baru</strong
                >
              </v-btn>

              <v-btn
                color="error"
                elevation="2"
                outlined
                dark
                min-width="140"
                :loading="loadingProcess"
                :class="isMobile ? 'v-btn--block mb-3' : 'mr-2'"
                v-if="isMobile"
                @click="cancelForm"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold"
                  >Batal</strong
                >
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import uploadFileVue from "./components/uploadFile.vue";
const defaultInput = () => ({
  nama: "",
  slug: "",
  kategori: "",
  kondisi: "1",
  deskripsi: "",
  minOrder: 0,
  hargaSatuan: "",
  hargaB2b: "",
  status: "active",
  stok: 0,
  berat: 0,
  unitberat: 0,
  unit: "",
  asuransi: 0,
  image: [],
  isMobile: false,
  product_gross: 0,
  product_enable_discount: 0,
  product_discount_type: "nominal",
  product_discount_percent: 0,
  product_discount_nominal: 0,
  product_fee: 1,
  code: "",
  product_length: "",
  product_width: "",
  product_height: "",
  product_physique: "",
  product_ebook_file_type: "",
  product_ebook_orientation: "",
  product_ebook_files: [],
});
export default {
  components: {
    "upload-file": uploadFileVue,
  },
  data() {
    return {
      biayaLayananList: [
        { value: 5, title: "5%" },
        { value: 10, title: "10%" },
        { value: 15, title: "15%" },
        { value: 20, title: "20%" },
      ],
      selectedCategoryArr: {
        product_category_id: "0",
        product_category_fee_minimum: "0",
      },
      title: "",
      image_alert: false,
      isMobile: false,
      loadingProcess: false,
      nameRules: [
        (v) => !!v || "Nama produk tidak boleh kosong",
        (v) => v.length >= 5 || "Nama produk minimal 5 karakter",
      ],
      unitRules: [(v) => !!v || "Satuan produk tidak boleh kosong"],
      categoryRules: [(v) => !!v || "Kategori produk tidak boleh kosong"],
      valueRules: [(v) => !!v || "Nilai tidak boleh kosong"],
      priceRules: [(v) => !!v || "Harga produk tidak boleh kosong"],
      priceB2bRules: [
        (v) => !!v || "Harga produk tidak boleh kosong",
        () =>
          parseInt(this.produkInput.hargaB2b) <
            parseInt(this.produkInput.hargaSatuan) ||
          "Harga B2B harus lebih rendah daripada harga satuan",
      ],
      stockRules: [(v) => !!v || "Stok produk tidak boleh kosong"],
      weightUnitRules: [(v) => !!v > 0 || "Tidak boleh kosong"],
      weightRules: [(v) => parseInt(v) > 0 || "Tidak boleh kosong"],
      physiqueRules: [(v) => !!v || "Jenis file produk tidak boleh kosong"],
      ebookFileTypeRules: [(v) => !!v || "Tipe file produk tidak boleh kosong"],
      imgPreview: [],
      produkInput: defaultInput(),
      units: ["unit", "pcs", "lembar", "kotak"],
      weightUnits: [
        { text: "Gram (g)", multiple: 1 },
        // { text: "Kilogram (Kg)", multiple: 1000 }
      ],
      isProductPhysique: false,
      isProductEbookFileType: false,
      productPhysiqueData: [
        {
          label: "Fisik",
          value: "physique",
        },
        {
          label: "Ebook",
          value: "ebook",
        },
      ],
      productEbookFileTypeData: [
        {
          label: "Image",
          value: "image",
        },
        // {
        //   label: "Pdf",
        //   value: "pdf",
        // },
      ],
      productEbookOrientationData: [
        {
          label: "Portrait",
          value: "portrait",
        },
        {
          label: "Landscape",
          value: "landscape",
        },
      ],
    };
  },

  computed: {
    ...mapState("category", ["category"]),
    ...mapState("productSeller", ["responseError", "detailProduct"]),
    ...mapState("storeSeller", ["detailStore"]),
    checkUploadEbook() {
      if (!this.produkInput.product_ebook_file_type) return false;
      if (this.produkInput.product_ebook_file_type == "pdf") return true;
      if (this.produkInput.product_ebook_file_type == "image") {
        if (!this.produkInput.product_ebook_orientation) return false;
        return true;
      }
    },
    imgProduct() {
      let img = [];
      for (var i = 0; i < 5; i++) {
        img[i] = this.imgPreview[i] ? this.imgPreview[i].img : undefined;
      }
      return img;
    },
  },
  watch: {
    "produkInput.product_physique": {
      handler: function (nv) {
        if (nv == "ebook") {
          this.produkInput.unitberat = 1;
          this.produkInput.berat = 1;
          this.produkInput.product_length = 1;
          this.produkInput.product_width = 1;
          this.produkInput.product_height = 1;
        } else {
          this.produkInput.unitberat = "";
          this.produkInput.berat = "";
          this.produkInput.product_length = "";
          this.produkInput.product_width = "";
          this.produkInput.product_height = "";
          this.isProductEbookFileType = false
        this.produkInput.product_ebook_orientation = "";
        }
      },
      deep: true,
      immediate: true,
    },
    "produkInput.product_ebook_file_type": {
      handler: function (nv) {
        this.produkInput.product_ebook_files = [];
      },
      deep: true,
      immediate: true,
    },
    "produkInput.product_physique": {
      handler: function (nv) {
        this.produkInput.product_ebook_files = [];
      },
      deep: true,
      immediate: true,
    },
    "produkInput.product_ebook_orientation": {
      handler: function (nv) {
        this.produkInput.product_ebook_files = [];
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    getCategorySelected(id) {
      this.selectedCategoryArr = this.category.find(
        (x) => x.product_category_id === id
      );
      this.produkInput.product_fee =
        this.selectedCategoryArr.product_category_fee_minimum * 1;
      return this.selectedCategoryArr;
    },
    getPhysiqueSelected(value) {
      if (value == "ebook") {
        this.isProductPhysique = true;
        this.produkInput.product_ebook_file_type = "";
        this.produkInput.product_ebook_orientation = "";
      } else {
        this.isProductPhysique = false;
        this.produkInput.product_ebook_file_type = "";
        this.produkInput.product_ebook_orientation = "";
      }
    },
    getEbookFileTypeSelected(value) {
      if (value == "image") {
        this.isProductEbookFileType = true;
        this.produkInput.product_ebook_orientation = "";
      } else {
        this.isProductEbookFileType = false;
        this.produkInput.product_ebook_orientation = "";
      }
    },
    ...mapActions("category", ["getCategory"]),
    ...mapActions("productSeller", [
      "addProduct",
      "addProductB2b",
      "uploadImage",
      "getProductDetail",
    ]),
    ...mapMutations("productSeller", ["clearProduct"]),
    ...mapMutations(["makeAlert"]),
    ...mapActions("storeSeller", ["getStoreDetail"]),
    isEnableDiscount() {
      if (this.produkInput.product_enable_discount == 0) {
        this.produkInput.product_discount_percent = 0;
        this.produkInput.product_discount_nominal = 0;
        this.calculatePrice();
      }
    },
    // changeDiscountType() {
    //   this.produkInput.product_discount_percent = 0;
    //   this.produkInput.product_discount_nominal = 0;
    // },
    calculatePrice() {
      if (this.produkInput.product_enable_discount == 1) {
        if (
          this.produkInput.product_discount_percent > 0 &&
          this.produkInput.product_discount_type == "percent"
        ) {
          if (this.produkInput.product_discount_percent > 70) {
            this.produkInput.product_discount_percent = 70;
          }
          this.produkInput.product_discount_nominal = Math.ceil(
            this.produkInput.product_gross *
              (this.produkInput.product_discount_percent / 100)
          );

          this.produkInput.hargaSatuan =
            this.produkInput.product_gross -
            this.produkInput.product_discount_nominal;
        } else {
          this.produkInput.hargaSatuan =
            this.produkInput.product_gross -
            this.produkInput.product_discount_nominal;
          this.produkInput.product_discount_percent = Math.ceil(
            (this.produkInput.product_discount_nominal /
              this.produkInput.product_gross) *
              100
          );
          if (this.produkInput.product_discount_percent > 70) {
            this.produkInput.product_discount_percent = 70;
            this.produkInput.product_discount_nominal = Math.ceil(
              this.produkInput.product_gross *
                (this.produkInput.product_discount_percent / 100)
            );
          }
        }
      } else {
        this.produkInput.hargaSatuan = this.produkInput.product_gross;
      }
    },
    removeImage(index) {
      this.imgPreview.splice(index, 1);
    },
    async openUpload() {
      const input = await document.getElementById("inputProdukImg");
      input.click();
    },
    createImage(event) {
      var dimensions = [];
      event.forEach((el) => {
        dimensions.push(
          new Promise(function (resolve) {
            var reader = new FileReader();
            reader.onload = (e) => {
              resolve({
                img: e.target.result,
                file: el,
              });
            };
            reader.readAsDataURL(el);
          })
        );
      });

      Promise.all(dimensions)
        .then((res) => {
          if (this.imgPreview.length + res.length > 5)
            this.makeAlert({
              code: "error_response",
              type: "error",
              message: "Gambar maksimal 5",
              show: true,
            });

          res.splice(5 - this.imgPreview.length, res.length - 1);
          this.imgPreview = [...this.imgPreview, ...res];

          if (this.imgPreview.length > 0) this.image_alert = false;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    upload(type) {
      var dimensions = [];
      this.imgPreview.forEach((el) => {
        dimensions.push(
          new Promise((resolve) => {
            let formData = new FormData();
            formData.append("image", el.file);
            this.uploadImage(formData).then((res) => {
              resolve(res.product_image);
            });
          })
        );
      });

      Promise.all(dimensions)
        .then((dims) => {
          this.produkInput.image = dims;
          let resetProduct = (type) => {
            this.$refs.formAddProduct.resetValidation();
            this.$refs.fileupload.clearableCallback();
            this.imgPreview = [];
            this.produkInput = defaultInput();
            this.loadingProcess = false;
            if (type === 2) this.$router.push("/seller/produk-saya");
          };
          if (this.detailStore.store_is_b2b == "false") {
            let params = {
              category_id: this.produkInput.kategori,
              code: this.produkInput.code,
              name: this.produkInput.nama,
              description: this.produkInput.deskripsi,
              price: this.produkInput.hargaSatuan,
              weight: this.produkInput.berat * this.produkInput.unitberat,
              unit: this.produkInput.unit,
              quantity: this.produkInput.stok,
              status: this.produkInput.status,
              image: this.produkInput.image,
              product_gross: this.produkInput.product_gross,
              product_enable_discount: this.produkInput.product_enable_discount,
              product_discount_type: this.produkInput.product_discount_type,
              product_discount_percent:
                this.produkInput.product_discount_percent,
              product_discount_nominal:
                this.produkInput.product_discount_nominal,
              product_fee: this.produkInput.product_fee,
              product_length: this.produkInput.product_length,
              product_width: this.produkInput.product_width,
              product_height: this.produkInput.product_height,
              product_physique: this.produkInput.product_physique,
              product_ebook_file_type: this.produkInput.product_ebook_file_type,
              product_ebook_orientation:
                this.produkInput.product_ebook_orientation,
              product_ebook_files: this.produkInput.product_ebook_files,
            };
            this.addProduct(params)
              .then(() => {
                resetProduct(type);
              })
              .catch(() => {
                this.loadingProcess = false;
              });
          } else if (this.detailStore.store_is_b2b == "true") {
            let params = {
              category_id: this.produkInput.kategori,
              code: this.produkInput.code,
              name: this.produkInput.nama,
              description: this.produkInput.deskripsi,
              price: this.produkInput.hargaSatuan,
              price_original: this.produkInput.hargaB2b,
              weight: this.produkInput.berat * this.produkInput.unitberat,
              unit: this.produkInput.unit,
              quantity: this.produkInput.stok,
              status: this.produkInput.status,
              image: this.produkInput.image,
              product_gross: this.produkInput.product_gross,
              product_enable_discount: this.produkInput.product_enable_discount,
              product_discount_type: this.produkInput.product_discount_type,
              product_discount_percent:
                this.produkInput.product_discount_percent,
              product_discount_nominal:
                this.produkInput.product_discount_nominal,
              product_fee: this.produkInput.product_fee,
              product_length: this.produkInput.product_length,
              product_width: this.produkInput.product_width,
              product_height: this.produkInput.product_height,
              product_physique: this.produkInput.product_physique,
              product_ebook_file_type: this.produkInput.product_ebook_file_type,
              product_ebook_orientation:
                this.produkInput.product_ebook_orientation,
              product_ebook_files: this.produkInput.product_ebook_files,
            };
            this.addProductB2b(params)
              .then(() => {
                resetProduct(type);
              })
              .catch(() => {
                this.loadingProcess = false;
              });
          }
        })
        .catch(function (err) {
          console.log(err);
          this.loadingProcess = false;
        });
    },
    async save(type) {
      if (this.$refs.formAddProduct.validate()) {
        this.loadingProcess = await true;
        if (this.imgPreview.length > 0) {
           if(this.produkInput.product_physique == 'ebook'){
            this.produkInput.unitberat = 1;
            this.produkInput.berat = 1;
            this.produkInput.product_length = 1;
            this.produkInput.product_width = 1;
            this.produkInput.product_height = 1;
          }
          this.image_alert = false;
          await this.upload(type);
        } else {
          this.image_alert = true;
          this.loadingProcess = false;
        }
      }
    },
    cancelForm() {
      this.$router.push("/seller/produk-saya");
    },
    toggleAlert(val) {
      this.image_alert = val;
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
  },
  created() {
    this.$store.dispatch("setPageTitle", `Tambah Produk`);
    this.getStoreDetail();
    this.getCategory();
  },
  beforeDestroy() {
    this.clearProduct();
  },
};
</script>

<style lang="scss" scoped>
.product-img {
  border: 2px solid green;
  border-radius: 4px;

  &.emptyImg {
    border: 2px solid #ddd;
  }
}
.product-img {
  position: relative;
  .close-btn {
    position: absolute;
    top: -15px;
    right: -15px;
    height: 28px;
    width: 28px;
  }
}
</style>
